import { FlowButton } from 'components/ui/flow-button';

import { motion } from 'framer-motion';
import { ArrowLeft, Compass } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-br from-canvas via-surface to-canvas" />
      <div className="absolute inset-0 grain-overlay" />

      {/* Animated geometric elements */}
      <motion.div
        animate={{
          rotate: 360,
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "linear"
        }}
        className="absolute -top-24 -right-24 w-96 h-96 border border-gold/10 rounded-full"
      />

      <div className="site-content-shell relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="w-20 h-20 border border-gold/20 rounded-full flex items-center justify-center mx-auto mb-12 group transition-all duration-700 hover:border-gold/60">
            <Compass className="w-10 h-10 text-accent-ink group-hover:rotate-180 transition-transform duration-700" strokeWidth={1} />
          </div>

          <h1 className="font-display text-8xl md:text-[10rem] font-bold text-ink tracking-tighter leading-none mb-4 opacity-5">
            404
          </h1>

          <div className="relative -mt-12 md:-mt-20">
            <h2 className="font-display text-3xl md:text-5xl text-ink mb-6 tracking-tight">
              Coordinates Lost
            </h2>
            <p className="font-body text-copy/40 text-base md:text-lg leading-relaxed max-w-md mx-auto mb-12">
              The page you are looking for has been moved or does not exist in our current operational matrix.
            </p>

            <FlowButton
              to="/"
              className="  px-10 py-4 text-[11px] uppercase tracking-[0.2em] font-body font-bold  transition-all inline-flex items-center gap-3 "
            >
              <ArrowLeft className="w-4 h-4" /> Return to Base
            </FlowButton>
          </div>
        </motion.div>
      </div>

      {/* Decorative corners */}
      <div className="absolute top-12 left-12"><div className="w-12 h-12 border-t border-l border-gold/15" /></div>
      <div className="absolute bottom-12 right-12"><div className="w-12 h-12 border-b border-r border-gold/15" /></div>
    </div>
  );
}
